import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError, InternalAxiosRequestConfig } from "axios";

let authTokenGetter: (() => string | null) | null = null;

export function setAuthTokenGetter(getter: () => string | null) {
  authTokenGetter = getter;
}

export const apiClient: AxiosInstance = axios.create({
  baseURL: "/api",
  withCredentials: true,
});

// Simple in-flight de-duplication by method+url+params+data
const pending = new Map<string, AbortController>();

function buildKey(config: AxiosRequestConfig) {
  const { method, url, params, data } = config;
  return JSON.stringify({ method, url, params, data });
}

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  // Attach auth token if available
  const token = authTokenGetter ? authTokenGetter() : null;
  if (token) {
    config.headers = config.headers || {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }

  // De-duplicate identical in-flight requests
  const key = buildKey(config);
  if (!config.signal && pending.has(key)) {
    // cancel previous in-flight
    const controller = pending.get(key)!;
    controller.abort();
    pending.delete(key);
  }
  const controller = new AbortController();
  config.signal = controller.signal;
  pending.set(key, controller);
  return config;
});

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    const key = buildKey(response.config);
    pending.delete(key);
    return response;
  },
  (error: AxiosError) => {
    try {
      const key = error.config ? buildKey(error.config) : "";
      if (key) pending.delete(key);
    } catch {}
    return Promise.reject(error);
  },
);


